export const isReportWholeLink = true;
export default (domain = '') => {
  const host = domain.split('.')[0] ? domain.split('.')[0] : '';
  switch (host) {
    case 'pre':
      return {
        localAppName: 'subscribe-pre',
        localClusterName: 'subscribe-mp-pre1',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user_pre',
      };
    case 'pre2':
      return {
        localAppName: 'subscribe-pre',
        localClusterName: 'subscribe-mp-pre2',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user_pre2',
      };
    case 't':
      return {
        localAppName: 'subscribe-test',
        localClusterName: 'hz-subscribe-mp-t',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user-test',
      };
    case 't1':
      return {
        localAppName: 'subscribe-test',
        localClusterName: 'hz-subscribe-mp-t1',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user-test1',
      };
    case 't2':
      return {
        localAppName: 'subscribe-test',
        localClusterName: 'hz-subscribe-mp-t2',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user-test2',
      };
    case 't3':
      return {
        localAppName: 'subscribe-test',
        localClusterName: 'hz-subscribe-mp-t3',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user-test3',
      };
    case 'mp':
    default:
      return {
        localAppName: 'subscribe-online',
        localClusterName: 'hz-statis-mp-docker-cm_online',
        remoteAppName: 'hz-subscribe-user',
        remoteClusterName: 'hz-subscribe-user-docker-cm_online',
      };
  }
};
